import React from "react";
import {
    AdLogType
} from "../UIHelpers";

export const AdLogTypeFormatter = (cellContent, row) => (
    AdLogType[row.type]
);
